<template>
  <div :class="componentClassName">
    <dt class="a-vdxb-application-summary-item__title">{{ title }}</dt>
    <dd class="a-vdxb-application-summary-item__description">
      <slot>{{ description }}</slot>
      <a-vdxb-caption-list v-if="notes">
        <li v-for="(note, index) in notes" :key="index">{{ note }}</li>
      </a-vdxb-caption-list>
    </dd>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AVdxbCaptionList from '@/components/atoms/vdxb-caption-list';

export default {
  name: 'a-vdxb-application-summary-item',
  components: {
    AVdxbCaptionList,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: null,
      valiator(value) {
        return value.match(/(null|alphanumeric)/);
      },
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    notes: {
      type: Array,
      default: null,
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-vdxb-application-summary-item', this.variant);
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
